var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4402_21901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6436 6.59389C11.6436 6.59389 11.6643 4.17604 13.0819 2.45471L13.1295 1.2681C13.1453 0.874515 12.8304 0.546875 12.4365 0.546875H11.5641C11.1702 0.546875 10.8554 0.874562 10.8712 1.2681L11.0791 6.46125L11.1249 6.51442C11.2891 6.55077 11.4613 6.5782 11.6437 6.59408L11.6436 6.59389Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7328 12.6643C22.0353 8.84402 20.1989 6.25912 17.6071 5.56758C14.9484 4.85819 14.2377 6.60963 12.0004 6.60963C9.76305 6.60963 9.0523 4.85824 6.39361 5.56758C3.8018 6.25912 1.9654 8.84402 2.26796 12.6643",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2573 19.9346C19.8379 18.9042 20.3798 17.7063 20.8553 16.4023",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14551 16.4023C4.66375 20.5664 6.85917 23.6486 8.83163 23.6486C10.6979 23.6486 10.5227 22.3882 12.0004 22.3882C13.4782 22.3882 13.3029 23.6486 15.1692 23.6486C16.2666 23.6486 17.433 22.6946 18.5134 21.131",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5788 1.88009C17.7846 1.00792 17.7902 0.351562 17.7902 0.351562C17.7902 0.351562 15.0614 0.416377 13.364 2.13987C11.6667 3.86336 11.6436 6.59283 11.6436 6.59283C11.6436 6.59283 14.3724 6.52802 16.0697 4.80453C16.5412 4.32584 16.8834 3.76952 17.1319 3.21569",
    fill: "#3ABBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3779 17.7838C16.2729 16.6653 15.6017 15.7496 14.5905 15.3442L10.6722 13.7715C8.23363 12.7928 5.2363 13.5249 3.15296 15.6083C2.02282 16.7384 2.63695 18.5031 4.13494 18.4281C6.16153 18.326 8.13051 18.6498 9.91514 19.3802L12.8242 20.57C14.517 21.2624 16.5553 19.6638 16.3779 17.7838Z",
    fill: "#EBE298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39825 12.6638H2.23121C1.19367 12.6638 0.352539 11.8227 0.352539 10.7852V14.5229C0.352539 15.5605 1.19367 16.4016 2.23121 16.4016H22.9435C23.3326 16.4016 23.648 16.0862 23.648 15.6971V13.3683C23.648 12.9793 23.3326 12.6638 22.9435 12.6638H8.80725",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76315 8.90625H2.23121C1.19367 8.90625 0.352539 9.74733 0.352539 10.7849",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.958 16.4006V15.3477",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7188 16.4006V15.3477",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4795 16.4006V15.3477",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2397 16.4006V15.3477",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 16.4006V15.3477",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76123 16.4006V15.3477",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52148 16.4006V15.3477",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28223 16.4006V15.3477",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04297 16.4006V15.3477",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4402_21901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyFat);
export default __webpack_public_path__ + "static/media/body-fat.2df48523c3051ac733e056616a20d66f.svg";
export { ForwardRef as ReactComponent };